import { EmptyState, Typography } from '@alpine-iq/ui-library';
import React from 'react';

type SmallEmptyProps = {
	content?: React.ReactNode;
	children?: React.ReactNode;
	style?: React.CSSProperties;
};

export default function SmallEmpty(props: SmallEmptyProps) {
	return (
		<tr>
			<td colSpan={'100%' as any}>
				<div
					css={`
						height: 250px;
						background-color: var(--white);
						width: 100%;
						display: flex;
						justify-content: center;
						align-items: center;
						flex-direction: column;
					`}
					style={props.style}
				>
					{props?.content || (
						<EmptyState variant="retailer-small">
							<Typography
								variant="body"
								css="color: var(--gray600);"
							>
								{props.children}
							</Typography>
						</EmptyState>
					)}
				</div>
			</td>
		</tr>
	);
}
